import { useEffect, useState } from 'react';

import axiosApiInstance from '@/api/shared/axios-instance';
import { REDUCERS } from '@/constants/reducers';
import CustomDrawer from '@/DesignSystem/components/drawer/CustomDrawer';
import { EVENTS_ACTIONS, EVENTS_CATEGORIES, EVENTS_LABELS, logEventTracker } from '@/helpers/events-helper';
import URL_FACTORY from '@/helpers/url-helper';

import FixturesNextLast from '../jugadores-v2/FixturesNextLast';
import CoeficienteAnalitica from '../jugadores-v2/information/CoeficienteAnalitica';
import EstadisticasLaLigaFantasy from '../jugadores-v2/information/EstadisticasLaLigaFantasy';
import JugadoresHeaderSection from '../jugadores-v2/information/JugadoresHeaderSection';
import JugadorEventosPorPartido from '../jugadores-v2/information/JugadorEventosPorPartido';
import JugadorPartidosGrid from '../jugadores-v2/information/JugadorPartidosGrid';
import ProximoPartido from '../jugadores-v2/information/ProximoPartido';
import ValorMercadoFantasyLaLiga from '../jugadores-v2/information/ValorMercadoFantasyLaLiga';
import JugadoresConvocatoriaSeleccion from '../jugadores-v2/JugadoresConvocatoriaSeleccion';
import LazyLoadWrapper from '../shared/wrappers/lazy-load-wrapper';
import PlacementModalComponent from '../ads-components/placements/placementModal';

const MasterPlayerModalComponent = ({ playerId, fantasyId, dispatch }) => {
    const [open, setOpen] = useState(false);
    const [player, setPlayer] = useState(null);
    const [cache, setCache] = useState([]);

    const handleClose = () => {
        setOpen(false);
        dispatch({ type: REDUCERS.HIDE_PLAYER_PROFILE });
    };

    useEffect(() => {
        if (fantasyId > 0 || playerId > 0) {
            const isCached = cache?.find(
                (x) => (x.fantasyId == fantasyId && fantasyId > 0) || (x.playerId == playerId && playerId > 0)
            );

            if (isCached) {
                setOpen(true);
                setPlayer(isCached.data);
                logEventTracker(EVENTS_ACTIONS.MASTER_PLAYER, EVENTS_CATEGORIES.OPEN, EVENTS_LABELS.CACHE);
                return;
            }

            const url = URL_FACTORY.GetPlayerInformation;

            const payload = {
                fantasyId: fantasyId,
                playerId: playerId,
            };

            dispatch({ type: REDUCERS.SHOW_SPINNER });

            logEventTracker(EVENTS_ACTIONS.MASTER_PLAYER, EVENTS_CATEGORIES.OPEN, EVENTS_LABELS.API);

            axiosApiInstance
                .post(url, payload)
                .then((response) => {
                    if (response?.data?.if) {
                        setOpen(true);
                        setPlayer(response?.data);
                        // Add response to cache
                        setCache((prevCache) => [
                            ...prevCache,
                            {
                                fantasyId: response?.data.fantasyPlayer?.information?.id,
                                playerId: response?.data?.if?.id,
                                data: response?.data,
                            },
                        ]);
                    }
                })
                .finally(() => {
                    dispatch({ type: REDUCERS.HIDE_SPINNER });
                });
        } else {
            setOpen(false);
        }
    }, [playerId, fantasyId]);

    if (!player || !open) {
        return null;
    }

    return (
        <CustomDrawer title={player?.if?.nm} open={open} onClose={handleClose}>
            <JugadoresHeaderSection player={player} />
            <FixturesNextLast player={player} teamId={player?.team?.id ?? player?.teamId} />
            <JugadoresConvocatoriaSeleccion player={player} />
            <PlacementModalComponent />
            <ProximoPartido player={player} slug={player?.if?.slug} />
            <EstadisticasLaLigaFantasy player={player} slug={player?.if?.slug} />
            <ValorMercadoFantasyLaLiga player={player} slug={player?.if?.slug} />
            <CoeficienteAnalitica player={player} slug={player?.if?.slug} />
            <PlacementModalComponent />
            <JugadorPartidosGrid player={player} />
            <LazyLoadWrapper>
                <JugadorEventosPorPartido player={player} />
            </LazyLoadWrapper>
        </CustomDrawer>
    );
};

export default MasterPlayerModalComponent;
